"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tipApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var tipApi = exports.tipApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/tip",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/tip",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/tip/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  remove: function remove(id) {
    return (0, _request.default)({
      url: "/tip/".concat(id, "/delete"),
      method: "post"
    });
  }
};